import { HiOutlineMenu, HiOutlineSun, HiOutlineMoon, HiOutlineBell } from 'react-icons/hi';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import OfflineIndicator from '../common/OfflineIndicator';
import { useAuth } from '../../context/AuthContext';

const Header = ({ onMenuClick }) => {
  const { theme, toggleTheme } = useTheme();
  const { lang, toggleLanguage } = useLanguage();
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-30 bg-white/80 dark:bg-ink-800/80 backdrop-blur-md border-b border-ink-100 dark:border-ink-700">
      <div className="flex items-center justify-between px-3 py-3 sm:px-6">
        {/* Left: menu button (mobile) + greeting */}
        <div className="flex items-center gap-2 sm:gap-3 min-w-0">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 text-ink-700 dark:text-ink-300 hover:bg-ink-100 dark:hover:bg-ink-700 rounded-xl"
            aria-label="Open menu"
          >
            <HiOutlineMenu className="w-6 h-6" />
          </button>

          <div className="hidden sm:block min-w-0">
            <p className="text-xs text-ink-500 dark:text-ink-400">
              {lang === 'bn' ? 'স্বাগতম' : 'Welcome back'},
            </p>
            <p className="text-sm font-semibold text-ink-900 dark:text-white truncate">
              {user?.name || (lang === 'bn' ? 'ব্যবহারকারী' : 'User')}
            </p>
          </div>
        </div>

        {/* Right: notifications + offline + lang + theme (help button removed — Welcome Kit is currently OFF) */}
        <div className="flex items-center gap-1">
          <OfflineIndicator />

          <button
            className="hidden sm:flex p-2 text-ink-600 dark:text-ink-300 hover:bg-ink-100 dark:hover:bg-ink-700 rounded-xl relative"
            aria-label="Notifications"
          >
            <HiOutlineBell className="w-5 h-5" />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-rose-500 rounded-full animate-pulse-dot" />
          </button>

          <button
            onClick={toggleLanguage}
            className="px-2.5 py-2 text-ink-600 dark:text-ink-300 hover:bg-ink-100 dark:hover:bg-ink-700 rounded-xl text-xs font-bold tracking-wide"
            title={lang === 'bn' ? 'English' : 'বাংলা'}
          >
            {lang === 'bn' ? 'BN' : 'EN'}
          </button>

          <button
            onClick={toggleTheme}
            className="p-2 text-ink-600 dark:text-ink-300 hover:bg-ink-100 dark:hover:bg-ink-700 rounded-xl"
            aria-label="Toggle theme"
          >
            {theme === 'light' ? (
              <HiOutlineMoon className="w-5 h-5" />
            ) : (
              <HiOutlineSun className="w-5 h-5 text-accent-400" />
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
